
import {
  Component, OnInit,
  ViewChild,
} from '@angular/core';
import { BaseChartDirective } from "ng2-charts";
import { Dashboard } from 'src/app/physician/models/dashboard';
import { PhysicianService } from 'src/app/physician/physician.service';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  ngOnInit() {
     this.physicianService.getDashboardDetails().subscribe(data => {
 
       this.dashBoardData = data;
       this.setUserChartData(data);
     });
   }
   isLoaded: boolean;
 
   dashBoardData: Dashboard;
   userChartData: any[] = [];
   marketPlaceChartData: any[] = [];
   healthCareChartData: any[] = [];
 
   @ViewChild(BaseChartDirective, { static: false }) chart: BaseChartDirective;
 
   constructor(private physicianService: PhysicianService) {
 
     this.physicianService.getDashboardDetails().subscribe(data => {
 
       this.dashBoardData = data;
       this.setUserChartData(data);
       this.isLoaded = true;
     });
   }
 
   setUserChartData(data: Dashboard) {
 
     this.userChartData = [
       { data: data.user.totalUsers, label: 'Total' },
       { data: data.user.totalNewUsers, label: 'New' },
       { data: data.user.totalActiveUsers, label: 'Active' }
     ]
     this.marketPlaceChartData = [
       { data: data.marketPlace.orders, label: 'Orders' },
       { data: data.marketPlace.pending, label: 'Pending' },
       { data: data.marketPlace.shipped, label: 'Shipped' },
       { data: data.marketPlace.delivered, label: 'Delivered' }
     ];
     this.healthCareChartData = [
       { data: data.healthCareProfession.totalHealthCareProfession, label: 'Total' },
       { data: data.healthCareProfession.totalNewHealthCareProfession, label: 'New' },
       { data: data.healthCareProfession.totalActiveHealthCareProfession, label: 'Active' }
     ]
     if (this.chart)
       this.chart.update();
   }
 
   public userChartOptions = {
     scaleShowVerticalLines: false,
     responsive: true,
     legend: { position: 'bottom' }
   };
   public userChartLabels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
   public userChartType = 'line';
 
   public userChartColors: Array<any> = [
     {
       borderColor: '#12B76A'
     },
     {
       borderColor: '#00C4E2'
     },
     {
       borderColor: '#F79009'
     }
   ];
   public chartLegend = true;
 
 
   public marketPlaceChartOptions = {
     scaleShowVerticalLines: false,
     responsive: true,
     legend: { position: 'bottom' }
   };
 
   public marketPlaceChartLabels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
   public marketPlaceChartType = 'bar';
 
   public marketPlaceChartColors: Array<any> = [
     {
       backgroundColor: '#12B76A'
     },
     {
       backgroundColor: '#F9E738'
     },
     {
       backgroundColor: '#FDB022'
     },
     {
       backgroundColor: '#00C4E2'
     }
   ];
 
 
   public healthCareChartOptions = {
     scaleShowVerticalLines: false,
     responsive: true,
     legend: { position: 'bottom' }
   };
   public healthCareChartLabels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
   public healthCareChartType = 'line';
 
   public healthCareChartColors: Array<any> = [
     {
       borderColor: '#12B76A'
     },
     {
       borderColor: '#00C4E2'
     },
     {
       borderColor: '#F79009'
     }
   ];
   public healthCareLegend = true;
 
 
   public activeChartOptions = {
     scaleShowVerticalLines: false,
     responsive: true,
     legend: { position: 'bottom' }
   };
 
   public activeChartLabels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
   public activeChartType = 'bar';
   public activeChartData = [
     { data: [65, 59, 80, 81, 56, 55, 40], label: 'Orders' },
     { data: [28, 48, 40, 21, 6, 20, 10], label: 'Pending' },
     { data: [35, 43, 30, 20, 30, 15, 10], label: 'Shipped' }
   ];
   public activeChartColors: Array<any> = [
     {
       backgroundColor: '#12B76A'
     },
     {
       backgroundColor: '#F9E738'
     },
     {
       backgroundColor: '#00C4E2'
     }
   ];
 }
 